var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"text":""},on:{"click":function($event){return _vm.$msal.signIn()}}},[_vm._v("login")])
}
var staticRenderFns = []

export { render, staticRenderFns }